const TIMEOUT_navigation = 300;

/**
 * The HTML element for navigation - both for mobile and desktop
 */
class Navigation extends HTMLElement {
    constructor() {
        super();

        this.isNavigationReady = false;
        this.mobileBreakpoint = 1024;

        // Media Queries
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    }

    connectedCallback() {
        this.navigationEl = this;
        this.navigationDrawer = this.navigationEl.querySelector('w3-drawer-navigation');
        this.mainNavigation = this.navigationEl.querySelector('.js-navigation');

        if (this.isMobile) {
            this.initMobileNavigation();
        } else {
            this.initDesktopNavigation();
        }
    }

    // ---------------------------------------------------------------------------------------------------------------------
    // Navigation Desktop
    // ---------------------------------------------------------------------------------------------------------------------
    initDesktopNavigation() {
        this.isNavItemHover = false;
        this.navigationEnterTimeout = {};
        this.navigationLeaveTimeout = {};
        this.navigationEls = this.navigationEl.querySelectorAll('.js-navigation-item');

        this.navigationDrawer.addEventListener('drawer--open', (e) => {
            this.isNavigationReady = true;
        });

        this.navigationDrawer.addEventListener('drawer--close', (e) => {
            this.isNavigationReady = false;
            this.resetNavigationDesktop();
        });

        this.bindDesktopEvents();
    }

    handleHoverItems(element) {
        this.navigationEl.classList.toggle('navigation-item-hovered', this.isNavItemHover);
        element.classList.toggle('hovered', this.isNavItemHover);
    }

    handleSubmenuOpen(targetNavigationEl) {
        // display target submenu only if target has one
        const openSubmenu = targetNavigationEl.hasAttribute('has-submenu');
        targetNavigationEl.classList.toggle('submenu-open', openSubmenu);

        if (openSubmenu) {
            this.navigationDrawer.classList.add('submenu-visible');
        } else {
            this.navigationDrawer.classList.remove('submenu-visible');
        }

        // settimeout transition duration to prevent background glitch between 2 submenus
        setTimeout(() => {
            // and remove all previous open submenu class except current open
            this.navigationEls.forEach(navigationEl => {
                if (navigationEl !== targetNavigationEl)
                navigationEl.classList.remove('submenu-open');
            });
        }, TIMEOUT_navigation);
    }

    bindDesktopEvents() {
        this.navigationEls.forEach(navigationEl => {
            navigationEl.addEventListener('mouseenter', (e) => {
                if (!this.isNavigationReady) { return; }

                // handle hover on mouseenter
                this.isNavItemHover = true;
                this.handleHoverItems(navigationEl);

                // handle submenu
                this.navigationEnterTimeout = setTimeout(() => {
                    this.handleSubmenuOpen(navigationEl);
                }, TIMEOUT_navigation);
            });

            navigationEl.addEventListener('mouseleave', () => {
                // handle hover on mouseleave
                this.isNavItemHover = false;
                this.handleHoverItems(navigationEl);

                // handle submenu on mouseleave
                clearTimeout(this.navigationEnterTimeout);
            });
        });
    }

    resetNavigationDesktop() {
        this.navigationEl.classList.remove('navigation-item-hovered', this.isNavItemHover);
        this.navigationEls.forEach(navigationEl => {
            navigationEl.classList.remove('submenu-open', 'hovered');
        });
    }
    

    // ---------------------------------------------------------------------------------------------------------------------
    // Navigation Mobile
    // ---------------------------------------------------------------------------------------------------------------------

    initMobileNavigation() {
        this.navigationDepth = 2; // there are 2 level of navigation
        this.navigationLists = {}; // { 1 : [nav-level-1], 2 : [nav-level-2] }
        this.currentMenuLevel = 1;
        this.previousLevelButtons = this.navigationEl.querySelectorAll('.js-navigation-mobile-previous');
        this.nextLevelButtons = this.navigationEl.querySelectorAll('.js-navigation-link');
        this.navigationCategory = this.navigationEl.querySelector('.js-navigation-mobile--category span');        

        this.bindMobileEvents();
    }

    bindMobileEvents() {
        for (let i = 1; i < this.navigationDepth; i++) {
            this.navigationLists[i] = this.navigationEl.querySelectorAll(`.js-navigation-item[data-level="${i}"]`);
        }

        this.navigationDrawer.addEventListener('drawer--close', (e) => {
            this.setActiveLevel(1);
            this.resetNavigationMobile();
        });

        // init previous level buttons
        this.previousLevelButtons.forEach(previousLevelButton => {
            previousLevelButton.addEventListener('click', () => {
                this.setActiveLevel(this.currentMenuLevel - 1);
                this.resetNavigationMobile();
            });
        });

        this.nextLevelButtons.forEach(nextLevelButton => {
            nextLevelButton.addEventListener('click', (e) => {
                const li = nextLevelButton.parentNode;
                const hasSubmenu = li.hasAttribute('has-submenu');
                if (hasSubmenu) {
                    e.preventDefault();
                    this.updateNavigation(li);
                }
            });
        });
    }

    /**
     * Update navigation from a link element with a data attribute "level"
     * @param button
     */
     updateNavigation(li) {
        this.setActiveLevel(li.dataset.targetLevel);

        let nav = li.querySelector(`.js-navigation--level-${li.dataset.targetLevel}`);

        if (this.navigationCategory && nav) {
            this.navigationCategory.innerHTML = nav.dataset.parentName;
        }

        if (nav) {
            nav.classList.add('visible');
        }
    }

    resetNavigationMobile() {
        this.navigationLists[this.currentMenuLevel].forEach(li => {
            li.querySelector('ul').classList.remove('visible');
        });
    }

    /**
     * Set the active level of menu displayed. Accepts following values 1 | 2 | 3
     * @param level
     */
    setActiveLevel(level) {
        this.navigationEl.dataset.currentLevel = level;
        this.currentMenuLevel = level;
    }
}

customElements.define('w3-navigation', Navigation);

